const EU_GDPR_COUNTRY_CODES = [
    'AT', // Austria
    'BE', // Belgium
    'BG', // Bulgaria
    'HR', // Croatia
    'CY', // Cyprus
    'CZ', // Czech Republic
    'DK', // Denmark
    'EE', // Estonia
    'FI', // Finland
    'FR', // France
    'DE', // Germany
    'GR', // Greece
    'HU', // Hungary
    'IE', // Ireland
    'IT', // Italy
    'LV', // Latvia
    'LT', // Lithuania
    'LU', // Luxembourg
    'MT', // Malta
    'NL', // Netherlands
    'PL', // Poland
    'PT', // Portugal
    'RO', // Romania
    'SK', // Slovakia
    'SI', // Slovenia
    'ES', // Spain
    'SE', // Sweden
    'IS', // Iceland (EEA)
    'LI', // Liechtenstein (EEA)
    'NO', // Norway (EEA)
];

const UK_GDPR_COUNTRY_CODES = ['GB'];

const GDPR_DOCUMENTS = {
    EU: 'https://assets.stanwith.me/legal/EU_GDPR.pdf',
    UK: 'https://assets.stanwith.me/legal/UK_GDPR.pdf',
};

/**
 * Returns the appropriate GDPR compliance document URL based on country code.
 * Returns undefined if the country is not in EU/EEA or UK.
 */
export function getGDPRComplianceDocument(country?: string): string | undefined {
    if (!country) return undefined;

    const upperCountry = country.toUpperCase();

    if (EU_GDPR_COUNTRY_CODES.includes(upperCountry)) {
        return GDPR_DOCUMENTS.EU;
    }

    if (UK_GDPR_COUNTRY_CODES.includes(upperCountry)) {
        return GDPR_DOCUMENTS.UK;
    }

    return undefined;
}
